export enum ToolTheme {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}
